module.exports = __webpack_public_path__ + "img/grand-restaurant-2.2330a89c.jpg";